
export interface ISVPlayer {
    id:string,
    ind: number,
    audio: string,
    thumb: string
    title: string,
    group: string,
    svImage: string,
    isBypass: boolean
}
export enum svPlayerType {
    effects = 0,
    instruments = 1
}